import { useCallback } from 'react';
import type { ElasticRetailer } from '@//app/api/retailers/[slug]';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import type { LegacyTrackPhoneNumberCallRetailerEventData } from './legacy-types';

export const createLegacyTrackPhoneNumberCallRetailer = (
  branch: ElasticRetailer,
): LegacyTrackPhoneNumberCallRetailerEventData => {
  const eventData: LegacyTrackPhoneNumberCallRetailerEventData = {
    eventType: 'other',
    conversionType: 'phonenumber-call-retailer',
    branch: {
      id: branch.id,
    },
    pageType: 'dealer page',
  };

  return eventData;
};

export const useLegacyTrackPhoneNumberCallRetailer = () => {
  const { track } = useLegacyTracking();

  const trackLegacyTrackPhoneNumberCallRetailer = useCallback(
    (branch: ElasticRetailer) => {
      // Track event with only the event-specific data
      // The provider will inject base data (source, url, eventTimestamp, userData)
      track({
        event: 'other',
        data: createLegacyTrackPhoneNumberCallRetailer(branch),
      });
    },
    [track],
  );

  return {
    trackLegacyTrackPhoneNumberCallRetailer,
  };
};
